/**
 * NDJSON serialisation and the download filename — the two pure pieces of the download
 * path ([log-format.md §1](../docs/log-format.md)), kept out of the DOM so they test
 * without a browser. The Blob assembly and anchor click live in main.ts.
 */
import type { LogRecord } from './log';

/** One record as a JSON object plus a trailing newline. */
export function toNdjsonLine(rec: LogRecord): string {
  return JSON.stringify(rec) + '\n';
}

/** `evbweb-<yyyymmdd>T<hhmmss>Z-<session8>.ndjson`, UTC. */
export function downloadName(session: string, date: Date): string {
  const p = (n: number): string => String(n).padStart(2, '0');
  const stamp =
    `${date.getUTCFullYear()}${p(date.getUTCMonth() + 1)}${p(date.getUTCDate())}` +
    `T${p(date.getUTCHours())}${p(date.getUTCMinutes())}${p(date.getUTCSeconds())}Z`;
  return `evbweb-${stamp}-${session.slice(0, 8)}.ndjson`;
}
